import { render, staticRenderFns } from "./appReviews.vue?vue&type=template&id=412d5575&scoped=true"
import script from "./appReviews.vue?vue&type=script&lang=js"
export * from "./appReviews.vue?vue&type=script&lang=js"
import style0 from "./appReviews.vue?vue&type=style&index=0&id=412d5575&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412d5575",
  null
  
)

export default component.exports